<template>
	<div class="index">
		<!-- banner图 -->
		<div class="newsCenterBanenr">
			<img src="../../assets/xiangning/tssz/tssz_banner.png">
		</div>
		<div class="tsszhome_wrap">
			<!-- 标题 -->
			<div class="news_title">
				<div class="title_left">
					<img src="../../assets/xiangning/home/titile_left.png" alt="">
				</div>
				<div class="news_title_left">
					<div v-for="item in yearList" class="news_title_left_item" :style="{color:getdata.year==item?'#C9010A':'#000000'}" @click="changeYear(item)" >{{ item}}</div>
				</div>
				<div class="right_back">
					<div class="right_back_icon"><img src="../../assets/xiangning/dwgk/back.png" alt=""></div>
					<div @click="$router.go(-1)">返回</div>
				</div>
			</div>
			<!-- 列表 -->
			<div class="contentList">
				<!-- 列表循环 -->
				<div @click="goDetail(item)" class="contentList_item" v-for="item in dataList" :key="item.id">
					<!-- 上方图片 -->
					<div class="top_img"><img :src="item.sz_img" alt="">
					</div>
					<!-- 下方标题 -->
					<div class="bottom_title">
						<div class="bottom_title_main">
							{{ item.title }}
						</div>
					</div>
				</div>
				<!-- 弹出框标题部分 -->
				<el-dialog :title="tsszTitle" :visible.sync="centerDialogVisible" width="50%" center>
					<!-- 图片部分 -->
					<div class="dialog_box_tssz">
						<div class="dialog_pic">
							<img :src="tsszSrc" alt="">
						</div>
					</div>
				</el-dialog>
			</div>
			<!-- 下方分页器 -->
			<Page :total="total" :per_page="per_page" :pageSize="[20]" @handleCurrentChange="handleCurrentChange">
			</Page>
			<div style="height: 40px;" class="bottom"></div>
		</div>

	</div>
</template>
<script>
import { news } from '@/axios';
import Page from '@/components/page.vue'
export default {
	data() {
		return {
			yearList:[],
			window:window,
			// 总数据条数
			total: 0,
			// 当前页码
			per_page: 1,
			year: 2022,
			// 模拟遍历数据
			dataList: [],
			index: 0,
			getdata: {
				page: 1,
				year: 2023
			},
			// 弹出框按钮
			centerDialogVisible: false,
			tsszTitle: '',
			tsszSrc: ''

		}
	},
	components: { Page },
	methods: {
		// 点击新闻中心切换标题
		changeNewsNum(val) {
			this.NewsNum = val
		},
		// 分页器页码发生变化
		handleCurrentChange(val) {
			this.getdata.page = val
			this.getDataList()
		},
		//   年份发生后变化
		changeYear(val) {
			this.getdata.year = val
			this.getdata.page = 1
			this.getDataList()
		},
		// 点击打开弹出框
		goDetail(data) {
			this.centerDialogVisible = true
			this.tsszTitle = data.title
			this.tsszSrc = data.sz_img

		},
		dtime(){
			let that = this
			news.tssztime(that.getdata).then(res => {
				if (res.code == 200) {
					that.getdata.year=res.data[0];
					that.yearList=res.data;
					that.getDataList();
				}
			})
		},
		getDataList() {
			let that = this
			news.tsszList(that.getdata).then(res => {
				if (res.code == 200) {
					this.dataList = res.data.pagedata
					this.total = res.data.count
				}
			})
		}

	},
	mounted() {
		// if(window.year[0].id<26){
		// 	this.window.year.unshift({id:2025});	
		// }
		// this.yearList=this.window.year
		// this.year=this.window.year[0].id
		// this.getdata.year=this.window.year[0].id
		this.dtime()
		
	},
	created() {
		this.$emit("highLight", this.$route.query.index, "", "", "");
	}
}
</script>

<style lang="scss">
@import '@/common/index.scss';

.index {
	width: 100%;

	.newsCenterBanenr {
		position: relative;
		width: 100%;

		img {
			width: 100%;
			height: auto;
		}
	}

	div {
		box-sizing: border-box;
	}

	.tsszhome_wrap {
		width: 1200px;
		margin: 0 auto;

		.news_title{
				
				height: 32px;
				width: 100%;
				margin:20px 0;
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding-left:32px;
				background: #FFF6F1;
				box-sizing: border-box;
				position: relative;
				.title_left{
					position: absolute;
					top: -5px;
					left: 0;
					height: 42px;
					width: 42px;
					img{
						width: 100%;
						height: 100%;
					}
				}
			}
		.news_title_left {
			width: 80%;
			height: 22px;
			padding-left: 20px;
			display: flex;

			.news_title_left_item {
				margin-right: 20px;
				font-family: PingFang SC;
				font-size: 16px;
				font-weight: normal;
				letter-spacing: 0.1em;

				color: #999999;
			}

		}

		.news_title_left_text {
			height: 22px;
			width: 80px;
			font-family: PingFangSC-Regular;
			font-size: 16px;
			font-weight: normal;
			letter-spacing: 0.1em;
			color: #999999;
		}

		.right_back {
			display: flex;
			font-family: PingFangSC-Regular;
			font-size: 12px;
			font-weight: normal;
			letter-spacing: 0em;
			color: #666666;
			margin-right: 10px;
		}

		.right_back:hover {
			font-weight: 800;
			color: #C9010A;
		}

		.right_back_icon {
			height: 10px;
			width: 12px;
			margin-right: 5px;
		}

		.right_back_icon img {
			height: 100%;
			width: 100%;
		}

		.contentList {
			margin-top: 20px;
			// height: 724px;
			width: 100%;
			margin-bottom: 20px;
			overflow: hidden;
			display: flex;
			justify-content: start;
			flex-wrap: wrap;
			align-content: start;

		}

		.contentList_item {
			height: 166px;
			width: 224px;
			margin-bottom: 20px;
			/* 修改圆角 */
			border-radius: 4px;
			overflow: hidden;
			margin-right: 20px;

		}

		.contentList_item:nth-child(5n) {
			margin-right: 0;
		}

		.top_img {
			width: 100%;
			height: 126px;
			/* 修改圆角 */
			border-radius: 4px 4px 0 0;
			overflow: hidden;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.bottom_title {
			height: 40px;
			width: 100%;
			border: 1px solid #ECEEF4;
			border-radius: 4px;
			display: flex;
			justify-content: center;
			align-items: center;
			/* 修改圆角 */
			border-radius: 0 0 4px 4px;
			overflow: hidden;

		}

		.bottom_title_main {
			height: 20px;
			width: 204px;
			font-family: PingFangSC-Medium;
			font-size: 14px;
			font-weight: 800;
			letter-spacing: 0em;
			color: #000000;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 1;
			/* 修改圆角 */
			border-radius: 4px;
			overflow: hidden;

		}

		.dialog_box_tssz {
			width: 100%;
			height: 500px;
			display: flex;
			justify-content: center;
		}

		.dialog_pic {
			/* height:700px; */
			width: 90%;
			overflow: auto;
			overflow: hidden;
			display: flex;
			align-items: center;

			img {
				width: 100%;
			}

		}

		.dialog_pic img {

			/* width: 100%;  */
		}


	}
}</style>
